import type { DirectiveBinding } from 'vue'
import { getPriceInfoFromSocketMessageBySymbolName } from '@/utils'
import { throttle } from 'lodash'
import Decimal from 'decimal.js'
// import { STORAGE_KEYS } from '@/constants'
// import storage from 'store'
// const { DARK_THEME } = STORAGE_KEYS
// const isDarkTheme = storage.get(DARK_THEME) === 1
// 使用 WeakMap 缓存 throttle 函数
const throttleMap = new WeakMap<HTMLElement, (message: string) => void>()

export const getPriceByIndex = ({
  priceInfo,
  indexList,
  precision = 2,
  emptyPlaceholder = '-',
  connector = '~',
}: {
  priceInfo: string[]
  indexList: number[]
  precision?: number
  emptyPlaceholder?: string
  connector?: string
}) => {
  let formattedValue = emptyPlaceholder
  const result = []

  for (const _index of indexList) {
    const _value = priceInfo[_index]
    if (!Number.isNaN(_value)) {
      // 是数值
      const transformValue = new Decimal(Number(_value)).toNumber().toFixed(precision)
      result.push(transformValue)
    } else {
      result.push('')
    }
  }
  formattedValue = result.length > 0 ? result.join(connector) : emptyPlaceholder
  return formattedValue
}

const getBackgroundColorAndTextColor = (newValue: number, oldValue: number) => {
  if (newValue > oldValue) {
    return { backgroundColor: '#22b049', color: 'white' }
  } else {
    return { backgroundColor: '#d84027', color: 'white' }
  }
}

const applyFormatting = (el: HTMLElement, binding: DirectiveBinding) => {
  const { value, arg } = binding
  const [symbolName = '', indexStr = '0', precisionStr = '2', throttleTime = '2000'] =
    arg?.split('-') ?? []
  const indexList = indexStr.split(':').map(parseInt)
  const precision = parseInt(precisionStr) || 2

  const throttleMs = parseInt(throttleTime) || 2000

  if (!throttleMap.has(el)) {
    const updateValue = throttle((message: string) => {
      const priceInfo = getPriceInfoFromSocketMessageBySymbolName(message, symbolName)
      const oldValue = el.innerText
      if (!oldValue) {
        el.textContent = '-'
        return
      }
      if (priceInfo) {
        // 获取新的价格值并格式化
        const newValue = getPriceByIndex({
          priceInfo,
          indexList,
          precision,
        })
        el.textContent = newValue

        // 获取背景颜色和字体颜色
        const _newValue = parseFloat(newValue)
        const _oldValue = parseFloat(oldValue)
        if (_newValue !== _oldValue) {
          const { backgroundColor, color } = getBackgroundColorAndTextColor(_newValue, _oldValue)
          el.style.backgroundColor = backgroundColor
          el.style.color = color
          setTimeout(() => {
            el.style.backgroundColor = 'transparent'
            el.style.color = '#363636'
          }, 500)
        }
      }
    }, throttleMs)

    throttleMap.set(el, updateValue)
  }

  // 调用缓存的 throttle 函数
  const updateValue = throttleMap.get(el)!
  updateValue(value)
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    applyFormatting(el, binding)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    applyFormatting(el, binding)
  },
}
